import { ref, computed, shallowRef, watch, defineAsyncComponent, h, nextTick, defineComponent } from "vue";
import { usePage } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";
const resolveCallback = ref();
var resolver = {
  setResolveCallback: (callback) => {
    resolveCallback.value = callback;
  },
  resolve: (name) => resolveCallback.value(name)
};
const plugin = {
  install(app, options) {
    resolver.setResolveCallback(options.resolve);
  }
};
const response = usePage().props;
const modal = computed(() => {
  var _a;
  return (_a = response.value) == null ? void 0 : _a.modal;
});
const props = computed(() => {
  var _a;
  return (_a = modal.value) == null ? void 0 : _a.props;
});
const key = computed(() => {
  var _a;
  return (_a = modal.value) == null ? void 0 : _a.key;
});
const componentName = ref();
const component = shallowRef();
const show = ref(false);
const vnode = ref();
const nonce = ref();
const setHeaders = (values) => {
  Object.entries(values).forEach(
    ([key2, value]) => ["post", "put", "patch", "delete"].forEach((method) => {
      axios.defaults.headers[method][key2] = value;
    })
  );
};
const resetHeaders = () => {
  const headers = ["X-Inertia-Modal-Key", "X-Inertia-Modal-Redirect"];
  headers.forEach(
    ([key2, value]) => ["get", "post", "put", "patch", "delete"].forEach((method) => {
      delete axios.defaults.headers[method][key2];
    })
  );
};
const updateHeaders = () => {
  var _a, _b, _c;
  setHeaders({
    "X-Inertia-Modal-Key": key.value,
    "X-Inertia-Modal-Redirect": (_a = modal.value) == null ? void 0 : _a.redirectURL
  });
  axios.defaults.headers.get["X-Inertia-Modal-Redirect"] = (_c = (_b = modal.value) == null ? void 0 : _b.redirectURL) != null ? _c : "";
};
const close = () => {
  show.value = false;
  resetHeaders();
};
const resolveComponent = () => {
  var _a, _b, _c, _d;
  if (nonce.value == ((_a = modal.value) == null ? void 0 : _a.nonce) || !((_b = modal.value) == null ? void 0 : _b.component)) {
    return close();
  }
  if (componentName.value != ((_c = modal.value) == null ? void 0 : _c.component)) {
    componentName.value = modal.value.component;
    if (componentName.value) {
      component.value = defineAsyncComponent(() => resolver.resolve(componentName.value));
    } else {
      component.value = false;
    }
  }
  nonce.value = (_d = modal.value) == null ? void 0 : _d.nonce;
  vnode.value = component.value ? h(component.value, {
    key: key.value,
    ...props.value
  }) : "";
  nextTick(() => show.value = true);
};
resolveComponent();
if (typeof window !== "undefined") {
  window.addEventListener("popstate", (event) => {
    nonce.value = null;
  });
}
watch(
  () => modal.value,
  () => {
    var _a;
    if (((_a = modal.value) == null ? void 0 : _a.nonce) !== nonce.value) {
      resolveComponent();
    }
  },
  { deep: true }
);
watch(() => key.value, updateHeaders);
const redirect = () => {
  var _a, _b, _c;
  var redirectURL = (_c = (_a = modal.value) == null ? void 0 : _a.redirectURL) != null ? _c : (_b = modal.value) == null ? void 0 : _b.baseURL;
  vnode.value = false;
  if (!redirectURL) {
    return;
  }
  return Inertia.visit(redirectURL, {
    preserveScroll: true,
    preserveState: true
  });
};
const useModal = () => {
  return {
    show,
    vnode,
    close,
    redirect
  };
};
const Modal = defineComponent({
  setup() {
    const { vnode: vnode2 } = useModal();
    return () => vnode2.value;
  }
});
export { Modal, plugin as modal, useModal };
